module.exports = "./img/de722d294952a38bbaf4effb80741bfa.jpg";